import Vue from 'vue'
import './pollyfills'
import VueSignaturePad from 'vue-signature-pad'
import VueRouter from 'vue-router'
import VueNotify from 'vue-notifyjs'
import VeeValidate from 'vee-validate'
import lang from 'element-ui/lib/locale/lang/en'
import locale from 'element-ui/lib/locale'
import App from './App.vue'
import swal from 'sweetalert2'
// Plugins
import GlobalComponents from './gloablComponents'
import GlobalDirectives from './globalDirectives'
import SideBar from './components/UIComponents/SidebarPlugin'

// router setup
import routes from './routes/routes'

// library imports

import './assets/sass/paper-dashboard.scss'
import './assets/sass/element_variables.scss'
import './assets/sass/demo.scss'
import axios from 'axios'

import sidebarLinks from './sidebarLinks'


import store from './store'
import VueFormWizard from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import Select from 'element-ui/lib/select'

import VueCardFormat from 'vue-credit-card-validation'
import VueTelInput from 'vue-tel-input'
import 'vue-tel-input/dist/vue-tel-input.css'

// Library for mobile use (trigger for signature pads validation)
import Vue2TouchEvents from 'vue2-touch-events'

// Fix for element ui filters not working on mobile
Select.computed.readonly = function () {
  // trade-off for IE input readonly problem: https://github.com/ElemeFE/element/issues/10403
  const isIE = !this.$isServer && !Number.isNaN(Number(document.documentMode))
  // Edge 20+
  const isEdge = !isIE && !!window.StyleMedia

  if (this.filterable) {
    return !(this.filterable || this.multiple || !isIE && !isEdge) && !this.visible
  }

  return !this.filterable || this.multiple || !isIE && !isEdge && !this.visible
}

Vue.use(VueTelInput)
Vue.use(VueCardFormat)
Vue.use(VueSignaturePad)
Vue.use(VueFormWizard)
Vue.use(VueRouter)
Vue.use(GlobalDirectives)
Vue.use(GlobalComponents)
Vue.use(VueNotify)
Vue.use(SideBar, { sidebarLinks: sidebarLinks })
Vue.use(VeeValidate)
Vue.use(Vue2TouchEvents)
locale.use(lang)

// configure router
const router = new VueRouter({
  routes, // short for routes: routes
  linkActiveClass: 'active'
})

router.beforeEach((to, from, next) => {
  if (!to.query.lang) {
    if (!store.state.lang.value) {
      to.query.lang = 'EN'
      next({ path: to.path, query: to.query })
    } else {
      to.query.lang = store.state.lang.value
      next({ path: to.path, query: to.query })
    }
  } else {
    next()
  }
})


axios.interceptors.response.use(function (response) {
  return response
}, function (error) {
  if (error.response.status === 401) {
    localStorage.clear()
    window.location.href = store.state.configs.AWS_DOMAIN_NAME + '/login?response_type=code&client_id=' + store.state.configs.AWS_CLIENT_ID + '&redirect_uri=' + store.state.configs.AWS_REDIRECT_URL
  }
  if (error.response.status === 429) {
    swal('Error!', 'It looks like you already registered! Please check your email for the confirmation number or try again later', 'error')
      .then(function (result) {
        // let lang = store.state.lang.value
        // router.push({ path: '/', query: lang })
        window.location.reload()
      })
      .catch(swal.noop)
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  render: h => h(App),
  router,
  store
})



// WEBPACK FOOTER //
// ./src/main.js